<script lang="ts">
	import GradientBorder from '$lib/util/GradientBorder.svelte';
	import { addDollarSign, getNumBackInUnits } from '$lib/util/util';
	import { walletConnected } from '$lib/wallet/store';
	import { quintOut } from 'svelte/easing';
	import { scale } from 'svelte/transition';
	import { fetchingMarkets, markets } from '../../store';
	import { sumOfAllUserMargin } from '../../userInteract/store';
	import ScMarket from './SCMarket.svelte';
	import ScAutoConfig from '../utils/SCAutoConfig.svelte';
	import WithdrawAllUnusedMargins from '../utils/WithdrawAllUnusedMargins.svelte';
</script>

<div in:scale={{ duration: 250, delay: 0, opacity: 0.5, start: 0.98, easing: quintOut }}>
	<GradientBorder
		gradient="bg-fx-gradient-6"
		paddingClass="p-px"
		borderRadius="rounded-lg"
		outerClassList="mb-4"
		innerClassList="bg-fx-gradient-8 p-4"
	>
		{#if !$markets && !$fetchingMarkets && $walletConnected}
			<div class="animate-pulse h-20 bg-fx-grey-700 w-full rounded-lg mt-4" />

			<div class="animate-pulse h-20 bg-fx-grey-700 w-full rounded-lg mt-4" />

			<div class="animate-pulse h-20 bg-fx-grey-700 w-full rounded-lg mt-4" />
		{:else if $fetchingMarkets}
			<div class="animate-pulse h-20 bg-fx-grey-700 w-full rounded-lg mt-4" />

			<div class="animate-pulse h-20 bg-fx-grey-700 w-full rounded-lg mt-4" />
		{:else if $markets && !$fetchingMarkets}
			<div class="flex justify-between">
				<div class="text-lg font-semibold text-fx-grey-300">Margins</div>
				<div class="text-fx-grey-200 font-semibold">
					{addDollarSign(getNumBackInUnits($sumOfAllUserMargin, 18, 2))}
				</div>
			</div>

			<WithdrawAllUnusedMargins />
			<div class="border-t my-3 border-fx-grey-600" />
			{#each $markets as market}
				<ScMarket {market} />
			{/each}
			<div class="border-t my-3 border-fx-grey-600" />

			<ScAutoConfig />
		{/if}
	</GradientBorder>
</div>
